module.exports = __webpack_public_path__ + "static/media/rosewood.f196b69d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/interiorColors/rosewood.jpg
// module id = 637
// module chunks = 0